module.exports = __webpack_public_path__ + "static/img/1.97b1dc2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/1.png
// module id = yEkm
// module chunks = 0